import React, { useEffect, useState } from 'react'
import UserContainerComponent from '../../components/usersComponents/UserContainerComponent';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import DataAPI from '../../api/DataApi';
import { Nullable } from 'primereact/ts-helpers';
import { InputText } from 'primereact/inputtext';
import { Link, useNavigate } from 'react-router-dom';

function Clientes() {
    const navigate = useNavigate();
    const [date1, setDate1] = useState(new Date());
    const [date2, setDate2] = useState(new Date());
    const [iniciando, setIniciando] = useState(true);
    const [cargando, setCargando] = useState(false);
    const [companies, setCompanies] = useState<Array<any>>([]);
    const [filterCompanies, setFilterCompanies] = useState<Array<any>>([]);
    const [emptyTableLabel , setEmptyTableLabel] = useState('Cargando...');
    const [searchValue, setSearchValue] = useState('');

    const datos = [
        {
            'document' : 'E310000000001',
            'date' : '29/09/2024',
            'status' : 'Aceptado',
            'amount' : '1200.00',
            'options' : '',
        }
    ];
    const statusBodyTemplate = (item:any) => {
        if ( item.status === 1 )
            return <Tag className='bg-green-700' value={'Activo'} severity={'success'}></Tag>;
        else 
            return <Tag className='bg-red-700' value={'Inactivo'} severity={'danger'}></Tag>;
    };
    const formatCurrency = (value:any) => {
        return value.amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const nameTemplate = (value:any) => {
        return (
            <div>
            <Link style={{ textDecoration: 'none', color: "#4b5563" }} to={'data/'+value.id}>
                { value.name }
            </Link>
            </div>
        );
    };

    useEffect(() => {
        if ( iniciando ) {
            setEmptyTableLabel('Cargando...');
            setIniciando(false);
            setCargando(true);
            let token: string = String(localStorage.getItem('token'));
            
            DataAPI.getWorkingCompanies(token).then((data: any)=> {
                // console.log(data);
                setCompanies(data.objeto);
                setFilterCompanies(data.objeto);
                setCargando(false);
                setEmptyTableLabel('No existen registros.');
            });
        }    
    }, [cargando, iniciando]);
    


    return (
        <UserContainerComponent>
            <div className='px-4 lg:px-8'>
                <p className='font-bold mt-2 lg:mt-8 text-lg underline'>Clientes</p>
                <div className='flex flex-row items-center'>
                    <i className='pi pi-search text-slate-400 absolute ml-5 select-none'></i>
                    <InputText id='TBbusqueda' name='TBbusqueda'
                        onChange={handleChange} 
                        className='w-full pl-10' placeholder='Buscar Cliente'
                        />
                </div>
                <div className="card mt-4 select-none text-xs hidden lg:block">
                    <DataTable value={filterCompanies} stripedRows
                        emptyMessage = {emptyTableLabel} >
                        {/* <Column field="name" header="Nombre"></Column> */}
                        <Column body={nameTemplate} header="Nombre"></Column>
                        <Column field="rnc" header="RNC/Ced."></Column>
                        <Column body={statusBodyTemplate} header="Estado"></Column>
                        <Column field='path' header="Folder"></Column>
                        {/* <Column field="options" header="Opciones"></Column> */}
                    </DataTable>
                </div>
                <div className="card mt-4 select-none text-xs lg:hidden">
                    <DataTable value={filterCompanies} stripedRows
                        emptyMessage = {emptyTableLabel} size='small' >
                        {/* <Column field="name" header="Nombre"></Column> */}
                        <Column body={nameTemplate} header="Nombre"></Column>
                        <Column field="rnc" header="RNC/Ced."></Column>
                        <Column body={statusBodyTemplate} header="Estado"></Column>
                        {/* <Column field="options" header="Opciones"></Column> */}
                    </DataTable>
                </div>
            </div>
        </UserContainerComponent>
    );

    function handleChange(event: React.FormEvent<HTMLInputElement>) {
        const input = event.currentTarget.value;
    
        if ( input === '' ) {
            setFilterCompanies(companies);
        } else {
            const data = companies.filter(datos => {
                return datos.name.toLowerCase().includes(input.toLowerCase())
                || datos.rnc.toLowerCase().includes(input.toLowerCase())
                || datos.path.toLowerCase().includes(input.toLowerCase())
            })
            setFilterCompanies(data);
        }
    }

    function checkCompany(id: number) {
        navigate('./data');
    }
}

export default Clientes;